import {NamaPresenter} from "./NamaPresenter";
import * as ts from "../common/Translator";
import {translateIdAr, translateIdEn} from "../common/Translator";
import * as metadata from "../common/Metadata";
import LayoutEditorTemplate from "../compiled-templates/LayoutEditorTemplate";
import * as OwnerType from "../constants/OwnerType";
import * as PreferencesRequest from "../constants/PreferencesRequest"
import * as EditScreenFieldLayout from "../constants/EditScreenFieldLayout"
import {NamaKonvaCanvas} from "./NamaKonvaCanvas";
import Konva from "konva/cmj/index";
import {internalGridSizeToPixels} from "../common/GUIUtilities";
import * as GridSize from '../constants/GridSize'
import {ajaxJSON, areEqual} from "../common/NamaCommon";
import {dropDownFiltering} from "../widgets/DropDownListWidget";

export class LayoutEditorPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
    }

    start() {
        let that = this;
        that.initEditor();
        that.drawEditor();
        let req = {};
        req.owner = {ownerType: OwnerType.Entity, ownerId: this.entityType};
        req.properties = [PreferencesRequest.EDIT_LAYOUT, PreferencesRequest.META_DATA];
        this.originalPages = [];
        this.originalGroupBlocks = [];
        this.originalGridBlocks = [];
        this.originalLists = [];
        this.originalActions = [];
        this.originalReports = [];
        this.originalDashBoard = [];
        req.editLayoutScreenName = that.viewName_();
        req.listLayoutScreenName = that.place.listViewName;
        this.gridEmptyCellHeight = 25;
        metadata.fetchPreferences(req, (preferences) => {
            this.preferences = preferences;
            metadata.prepareMetadataFieldsParents(this.preferences.metaData);
            that.fetchEditLayout(() => {
                that.drawScreen();
            });
        });
        this.HEADER_FIELD_TYPE = "HeaderField";
        this.GRID_FIELD_TYPE = "GridField";
        this.CREATED_COMPOSITE_FIELDS_COUNT = 0;
    }

    fetchEditLayout(callback) {
        ajaxJSON("screenModifierEditor", {
            documentId: this.id,
            forType: this.entityType,
            action: "fetchLayoutTillMe",
        }, (data) => {
            this.editLayoutTillMe = data;
            callback()
        })
    }

    viewName_() {
        return this.place.calcEditViewName();
    }

    get entityType() {
        return this.place.entityType;
    }

    get id() {
        return this.place.id;
    }

    initEditor() {
        let editorTemplate = $(LayoutEditorTemplate({translateId: ts.translateId}));
        let domBody = $('#example');
        editorTemplate.appendTo(domBody);
        window.document.body.style.backgroundImage = 'none';
        return editorTemplate;
    }

    drawEditor() {
        let transformers = this.transformers = [];
        this.cachedLayers = {};
        let canvas = this.canvas = new NamaKonvaCanvas({
            containerId: "layoutEditor",
            width: 1280,
            height: 720,
            shouldAddSelector: true,
            backgroundGridColumnCount: 2,
            backgroundGridCellHeight: 30,
        });
        canvas.draw();
        let noResizableTransformer = this.noResizableTransformer = new Konva.Transformer({
            rotateEnabled: false,
            draggable: true,
            shouldOverdrawWholeArea: false,
            resizeEnabled: false
        })
        transformers.push(noResizableTransformer);
        canvas.layer.add(noResizableTransformer);
        let headerFieldTransformer = this.headerFieldTransformer = new Konva.Transformer({
            rotateEnabled: false,
            draggable: true,
            shouldOverdrawWholeArea: false,
            flipEnabled: false,
            enabledAnchors: ['top-center', 'bottom-center', 'middle-right', 'middle-left'],
        })
        transformers.push(headerFieldTransformer);
        canvas.layer.add(headerFieldTransformer);
        let gridFieldTransformer = this.gridFieldTransformer = new Konva.Transformer({
            rotateEnabled: false,
            draggable: true,
            shouldOverdrawWholeArea: true,
            flipEnabled: false,
            enabledAnchors: ['middle-right', 'middle-left'],
        })
        transformers.push(gridFieldTransformer);
        canvas.layer.add(gridFieldTransformer);
        canvas.stage.on('click tap', (e) => {
            if (e.target instanceof Konva.Container) {
                this.clearAllTransformers();
            }
        })
    }

    drawScreen() {
        this.appendPagesDropDownAndSaveBtn();
        this.drawPages();
        this.changeLayer(0);
    }

    changeLayer(pageNumber) {
        let that = this;
        for (let layer of this.canvas.stage.getLayers())
            layer.remove();
        let targetedLayer = this.cachedLayers[pageNumber];
        if (!targetedLayer)
            return;
        this.canvas.stage.add(targetedLayer);
        let layerHeight = Math.max(...targetedLayer.getChildren().filter(l => l.height() && l.y() !== undefined).map(l => l.height() + l.y()))
        this.canvas.stage.height(layerHeight);
        for (let tr of this.transformers) {
            tr.nodes([]);
            tr.remove();
        }
        targetedLayer.add(...this.transformers);
        targetedLayer.draw();
        $("#arabicPageTitle").val(ts.translateNaMaTextAr(targetedLayer.getAttr("page").title));
        $("#englishPageTitle").val(ts.translateNaMaTextEn(targetedLayer.getAttr("page").title));
        $("#arabicPageTitle").on('change', function () {
            targetedLayer = that.cachedLayers[Number(that.pageDropDown.dataItem().value)];
            targetedLayer.getAttr("page").title = {
                arabicText: $(this).val(),
                englishText: $("#englishPageTitle").val()
            }
            that.pageDropDown.dataItem().text = ts.translateNaMaText(targetedLayer.getAttr("page").title)
            that.pageDropDown.refresh();
        })
        $("#englishPageTitle").on('change', function () {
            targetedLayer = that.cachedLayers[Number(that.pageDropDown.dataItem().value)];
            targetedLayer.getAttr("page").title = {
                arabicText: $("#arabicPageTitle").val(),
                englishText: $(this).val()
            }
            that.pageDropDown.dataItem().text = ts.translateNaMaText(targetedLayer.getAttr("page").title)
            that.pageDropDown.refresh();
        })
    }

    drawPages() {
        for (let i = 0; i < this.editLayout.pages.length; i++) {
            this.cachedLayers[i] = this.drawPage(i);
        }
    }

    drawPage(pageNumber) {
        let layer = new Konva.Layer();
        let blockY = 0;
        let index = 0;
        let currentPage = this.editLayout.pages[pageNumber];
        layer.setAttr("page", currentPage)
        for (let block of currentPage.blocks) {
            let group = this.createKonvaGroupFromBlock(block, layer, blockY, index);
            this.setGroupAndBorderRectHeight(group, block);
            index++;
            blockY = group.y() + group.height();
            layer.add(group);
        }
        this.originalPages.push(this.editLayout.pages[pageNumber]);
        return layer;
    }

    createKonvaGroupFromBlock(block, layer, blockY, index) {
        let group = new Konva.Group({
            name: "NamaBlock",
            index: index,
            width: 1280,
            x: 0,
            y: blockY,
            draggable: true,
            block: block
        });
        let borderRect = new Konva.Rect({
            width: 1280,
            fill: "#6b6b6b",
            strokeWidth: .5,
            stroke: "#000000",
            name: "borderRect"
        });
        borderRect.on('click', () => {
            this.canvas.stage.fire('click');
        });
        group.add(borderRect);
        let gridTitle = this.appendBlockTitle(block);
        group.add(gridTitle);
        gridTitle.on('click tap', () => {
            this.onBlockTitleClicked(group, block, layer);
        })
        this.appendBlockDraggingEvent(group, layer);
        if (block.editScreenGroup) {
            this.originalGroupBlocks.push(block);
            group.setAttr("fields", block.fields);
            this.drawGroupBlock(group, layer, block);
        } else if (block.editScreenGrid) {
            this.originalGridBlocks.push(block);
            group.setAttr("gridFields", block.columns)
            this.drawGridFields(block, group, layer);
        } else if (block.editScreenActionsBlock) {
            this.originalActions.push(...block.actions);
            group.setAttr("actions", block.actions);
            this.appendActionsToWidget(group, layer, block);
        } else if (block.editScreenDashBoard) {
            this.originalDashBoard.push(block);
            this.appendCustomEditScreenBlockKonvaGroup(group, "Dashboard View");
            group.setAttr("collapse", true);
        } else if (block.editScreenList) {
            this.originalLists.push(block);
            this.appendCustomEditScreenBlockKonvaGroup(group, "List View");
            group.setAttr("collapse", true);
        } else if (block.editScreenReport) {
            this.originalReports.push(block);
            this.appendCustomEditScreenBlockKonvaGroup(group, "Report View");
            group.setAttr("collapse", true);
        }
        return group;
    }

    appendBlockDraggingEvent(blockGroup, layer) {
        blockGroup.on("dragmove", () => {
            blockGroup.moveToTop();
            let position = blockGroup.getAbsolutePosition();
            let y = position.y;
            blockGroup.x(0);
            if (y < 0)
                blockGroup.y(0);
            if (y + blockGroup.height() > this.canvas.stage.height())
                blockGroup.y(this.canvas.stage.height() - blockGroup.height());
        })

        blockGroup.on("dragend", () => {
            let position = blockGroup.getAbsolutePosition();
            let y = position.y;
            let container = null;
            this.canvas.stage.find(".NamaBlock").forEach(namaBlock => {
                if (y > namaBlock.y() && y < namaBlock.y() + namaBlock.height())
                    container = namaBlock;
            })
            if (!container) {
                this.canvas.stage.find(".NamaBlock").forEach(namaBlock => {
                    if (y + blockGroup.height() > namaBlock.y() && y + blockGroup.height() < namaBlock.y() + namaBlock.height())
                        container = namaBlock;
                })
            }
            if (container) {
                if (blockGroup.getAttr("index") > container.getAttr("index"))
                    blockGroup.y(container.y() - 5);
                else
                    blockGroup.y(container.y() + 5);
                this.resetIndexes(this.canvas.stage.find(".NamaBlock"));
            }
            layer = this.cachedLayers[Number(this.pageDropDown.dataItem().value)];
            this.resetNamaBlocksHeights(layer);
        })
    }

    resetNamaBlocksHeights(layer) {
        let blocksY = 0;
        layer.find(".NamaBlock").sort((a, b) => this.sortByProperty(a, b, "index")).forEach(node => {
            node.y(blocksY);
            blocksY += node.height();
        })
        let layerHeight = Math.max(...layer.find(".NamaBlock").map(l => l.height() + l.y()))
        this.canvas.stage.height(layerHeight);
        this.noResizableTransformer.forceUpdate();
    }

    onBlockTitleClicked(group, block, layer) {
        let that = this;
        this.clearAllTransformers();
        this.noResizableTransformer.nodes([group]);
        group.moveToTop();
        this.noResizableTransformer.moveToTop();
        let pointerName = "";
        $("#props").append(
            `<div class="d-flex property flex-column" style="border: #69696b 1px solid;border-radius:10px;margin: 3px;padding: 3px">
                    <div class="d-flex justify-content-center py-1">
                    <h5 class="m-0">Block Properties</h5>
                    </div>
                    <hr class="my-1" style="height: 1px;width: 100%;background-color: #69696b">
                    <div class="d-flex justify-content-between px-2 py-1">
                    <div class="h6">Arabic Block Title</div>
                    <input id="arabicBlockTitle" type="text" style="width: 50%" value="${ts.translateNaMaTextAr(block.title)}">
                    </div>
                    <div class="d-flex justify-content-between px-2 py-1">
                    <div class="h6">English Block Title</div>
                    <input id="englishBlockTitle" type="text" style="width: 50%" value="${ts.translateNaMaTextEn(block.title)}">
                    </div>
                    <div class="d-flex" id="groupPropsActions" style="flex-wrap:wrap"></div></div>`);
        if (block.editScreenGroup) {
            this.onGroupTitleClicked(group, block, layer);
            pointerName = ts.translateTitledId(this.entityType, block) || "Edit Screen Group";
        } else if (block.editScreenGrid) {
            $(`<div class="d-flex justify-content-between px-2 py-1">
                    <div class="h6">Grid Size</div>
                    <input id="gridSizeDropDown" class="text-center" style="width: 50%">
                    </div>`).insertBefore('#groupPropsActions');
            this.onGridTitleClicked(block, group, layer);
            pointerName = ts.translateTitledId(this.entityType, block) || "Edit Screen Grid";
        } else if (block.editScreenActionsBlock) {
            this.onActionsBlockTitleClicked(block, group, layer);
            pointerName = ts.translateTitledId(this.entityType, block) || "Edit Screen Actions Block";
        } else if (block.editScreenDashBoard || block.editScreenList || block.editScreenReport) {
            if (group.getAttr("collapse") !== undefined)
                this.onCustomBlockTitleClicked(group, block, layer);
        } else {
            pointerName = ts.translateTitledId(this.entityType, block) || "Discussion";
        }
        $("#pointerName").text(pointerName);
        $("#arabicBlockTitle").on('change', function () {
            block.title = {
                arabicText: $(this).val(),
                englishText: $("#englishBlockTitle").val()
            }
            group.find(".gridTitle")[0].find("Text")[0].text(ts.translateTitledId(that.entityType, block));
        })
        $("#englishBlockTitle").on('change', function () {
            block.title = {
                arabicText: $("#arabicBlockTitle").val(),
                englishText: $(this).val()
            }
            group.find(".gridTitle")[0].find("Text")[0].text(ts.translateTitledId(that.entityType, block));
        })
    }

    onCustomBlockTitleClicked(group, block, layer) {
        if (group.getAttr("collapse") === true) {
            group.find(".customBlock")[0].height(0);
            group.find(".customBlock")[0].find('Text')[0].height(0);
            group.setAttr("collapse", false);
        } else {
            group.setAttr("collapse", true);
            group.find(".customBlock")[0].height(internalGridSizeToPixels(GridSize.XLarge));
            group.find(".customBlock")[0].find('Text')[0].height(internalGridSizeToPixels(GridSize.XLarge));
        }
        this.setGroupAndBorderRectHeight(group, block);
        this.reOrderNamaBlocksAndResetStageHeight(layer);
        this.clearAllTransformers();
        layer.draw();
        this.noResizableTransformer.nodes([group]);
        $("#props").append(
            `<div class="d-flex property flex-column" style="border: #69696b 1px solid;border-radius:10px;margin: 3px;padding: 3px">
                    <div class="d-flex justify-content-center py-1">
                    <h5 class="m-0">Block Properties</h5>
                    </div>
                    <hr class="my-1" style="height: 1px;width: 100%;background-color: #69696b">
                    <div class="d-flex justify-content-between px-2 py-1">
                    <div class="h6" style="width: 30%">Arabic Block Title</div>
                    <input id="arabicBlockTitle" type="text" style="width: 50%" value="${ts.translateNaMaTextAr(block.title)}">
                    </div>
                    <div class="d-flex justify-content-between px-2 py-1">
                    <div class="h6" style="width: 30%">English Block Title</div>
                    <input id="englishBlockTitle" type="text" style="width: 50%" value="${ts.translateNaMaTextEn(block.title)}">
                    </div>
                    <div class="d-flex" id="groupPropsActions" style="flex-wrap:wrap">
                    <button class="btn btn-danger m-1" id="deleteCustomBlock">Delete Block</button>
                  <button class="btn btn-success m-1" id="copyCustomBlockToAnotherPage">Copy Block To Another Page</button>
                  <button class="btn btn-success m-1" id="moveCustomBlockToAnotherPage">Move Block To Another Page</button>
            </div>
            </div>`);
        $("#deleteCustomBlock").on('click', () => {
            group.destroy();
            this.resetIndexes(layer.find(".NamaBlock"));
            layer.draw();
            this.resetNamaBlocksHeights(layer);
            let container;
            switch (block.namaClassTypeId) {
                case "EditScreenList":
                    container = this.originalLists;
                    break;
                case "EditScreenReport":
                    container = this.originalReports;
                    break;
                case "EditScreenDashBoard":
                    container = this.originalDashBoard;
                    break;
            }
            let indexOfBlock = container.indexOf(block);
            container.splice(indexOfBlock, 1);
        })
        $("#copyCustomBlockToAnotherPage").on('click', () => {
            this.moveGroupToAnotherLayer(false, group, layer);
        })
        $("#moveCustomBlockToAnotherPage").on('click', () => {
            this.moveGroupToAnotherLayer(true, group, layer);
        })
    }

    appendFieldDraggingEvent(elementGroup, parentGroup, block, layer, redrawMethod, elementGroupClassName, fieldsAttrName, classAttrName) {
        this.onFieldDraggingStart(elementGroup, parentGroup, fieldsAttrName);
        this.onFieldDraggingEnd(elementGroup, parentGroup, classAttrName, elementGroupClassName, fieldsAttrName, redrawMethod, block, layer);
    }

    onFieldDraggingEnd(elementGroup, parentGroup, classAttrName, elementGroupClassName, fieldsAttrName, redrawMethod, block, layer) {
        elementGroup.on('dragend', () => {
            let containerGroup = this.getContainerGroup(elementGroup);
            let fields = parentGroup.getAttr(fieldsAttrName);
            let myField = fields.filter(l => (l.id ? l.id : l) === elementGroup.getAttr("fieldId"))[0]
            let myFieldIndex = fields.indexOf(myField);
            fields.splice(myFieldIndex, 1);
            if (containerGroup === parentGroup || containerGroup.getAttr(fieldsAttrName) === undefined) {
                let intersectionGroup = this.fetchIntersectionElements(parentGroup, classAttrName, elementGroupClassName, elementGroup);
                if (intersectionGroup && intersectionGroup.length > 0) {
                    let intersectionField = this.fetchNearestIntersectionElement(elementGroup, parentGroup, intersectionGroup, fields);
                    let intersectionFieldIndex = fields.indexOf(intersectionField);
                    let fieldsBetweenIntersectionAndMyField = fields.slice(Math.min(myFieldIndex, intersectionFieldIndex) + 1, Math.max(myFieldIndex, intersectionFieldIndex));
                    let isThereSpannedBetweenUs = fieldsBetweenIntersectionAndMyField.length > 0 ? fieldsBetweenIntersectionAndMyField
                        .some(l => l.layout === EditScreenFieldLayout.alone || l.layout === EditScreenFieldLayout.spanned || l.layout === EditScreenFieldLayout.spanned2) : false;
                    fields.splice(myField.layout !== undefined && intersectionFieldIndex > myFieldIndex && !isThereSpannedBetweenUs ?
                        intersectionFieldIndex + 1 : intersectionFieldIndex, 0, myField);
                } else {
                    fields.splice(fields.length, 0, myField);
                }
                parentGroup.setAttr(fieldsAttrName, fields);
                redrawMethod(block, parentGroup, layer);
                let newElementGroup = parentGroup.getChildren().filter(l => l.getAttr("fieldId") === myField.id)[0];
                newElementGroup.fire('click');
            } else {
                let intersectionGroup = this.fetchIntersectionElements(containerGroup, classAttrName, elementGroupClassName, elementGroup);
                let newFields = containerGroup.getAttr(fieldsAttrName);
                if (intersectionGroup && intersectionGroup.length > 0) {
                    let intersectionField = this.fetchNearestIntersectionElement(elementGroup, containerGroup, intersectionGroup, newFields);
                    let intersectionFieldIndex = newFields.indexOf(intersectionField);
                    let fieldsBetweenIntersectionAndMyField = fields.slice(Math.min(myFieldIndex, intersectionFieldIndex) + 1, Math.max(myFieldIndex, intersectionFieldIndex));
                    let isThereSpannedBetweenUs = fieldsBetweenIntersectionAndMyField.length > 0 ? fieldsBetweenIntersectionAndMyField
                        .some(l => l.layout === EditScreenFieldLayout.alone || l.layout === EditScreenFieldLayout.spanned || l.layout === EditScreenFieldLayout.spanned2) : false;
                    newFields.splice(myField.layout !== undefined && intersectionFieldIndex > myFieldIndex && !isThereSpannedBetweenUs ?
                        intersectionFieldIndex + 1 : intersectionFieldIndex, 0, myField);
                } else {
                    newFields.splice(newFields.length, 0, myField);
                }
                parentGroup.setAttr(fieldsAttrName, fields);
                containerGroup.setAttr(fieldsAttrName, newFields);
                redrawMethod(block, parentGroup, layer);
                redrawMethod(containerGroup.getAttr("block"), containerGroup, layer);
                let newElementGroup = containerGroup.getChildren().filter(l => l.getAttr("fieldId") === myField.id)[0];
                newElementGroup.fire('click');
            }
        })
    }

    getContainerGroup(elementGroup) {
        let position = elementGroup.getAbsolutePosition();
        let parentGroup = null;
        this.canvas.stage.find(".NamaBlock").forEach(parent => {
            if (position.y > parent.y() && position.y < parent.y() + parent.height())
                parentGroup = parent;
        })
        return parentGroup;
    }

    fetchNearestIntersectionElement(elementGroup, parentGroup, intersectionGroup, fields) {
        let minDistance;
        let nearestElement;
        let position = elementGroup.getAbsolutePosition(parentGroup);
        let x = position.x;
        let y = position.y;
        intersectionGroup.forEach(n => {
            let distance = Math.sqrt(Math.pow(x - n.x(), 2) + Math.pow(y - n.y(), 2));
            if (!minDistance || distance < minDistance) {
                minDistance = distance;
                nearestElement = n;
            }
        });
        return fields.filter(l => (l.id ? l.id : l) === nearestElement.getAttr("fieldId"))[0];
    }

    fetchIntersectionElements(parentGroup, classAttrName, elementGroupClassName, elementGroup) {
        return parentGroup.getChildren().filter(l => l.getAttr(classAttrName) === elementGroupClassName)
            .filter(l => Konva.Util.haveIntersection(elementGroup.getClientRect(), l.getClientRect()))
            .filter(l => l.getAttr("fieldId") !== elementGroup.getAttr("fieldId"));
    }

    onFieldDraggingStart(elementGroup, parentGroup, fieldsAttrName) {
        elementGroup.on('dragmove', () => {
            parentGroup.moveToTop();
            elementGroup.moveToTop();
            let position = elementGroup.getAbsolutePosition(parentGroup);
            let x = position.x;
            let y = position.y;
            let blockTitleHeight = this.canvas.backgroundGridCellHeight;
            if (x < 0)
                elementGroup.x(0);
            if (x + elementGroup.width() > this.canvas.width)
                elementGroup.x(this.canvas.width - elementGroup.width());
            if (fieldsAttrName === "gridFields") {
                if (y < blockTitleHeight)
                    elementGroup.y(blockTitleHeight);
                if (y + elementGroup.height() > parentGroup.height())
                    elementGroup.y(parentGroup.height() - elementGroup.height());
            }
        })
    }

    appendHeaderFieldTransformEvent(elementGroup, parentGroup, block, layer) {
        elementGroup.on('transformend', () => {
                let newWidth = elementGroup.scaleX() * elementGroup.width();
                let newHeight = elementGroup.scaleY() * elementGroup.height();
                let currentField = parentGroup.getAttr("fields").filter(l => l.id === elementGroup.getAttr("fieldId"))[0];
                let newLayout;
                if (newWidth > elementGroup.width()) {
                    newLayout = EditScreenFieldLayout.spanned;
                } else if (newWidth === elementGroup.width()) {
                    if (currentField.layout === EditScreenFieldLayout.spanned || currentField.layout === EditScreenFieldLayout.spanned2) {
                        newLayout = newHeight < elementGroup.height() ? EditScreenFieldLayout.spanned : EditScreenFieldLayout.spanned2;
                    } else {
                        newLayout = currentField.layout;
                    }
                } else {
                    newLayout = EditScreenFieldLayout.normal;
                }
                currentField.layout = newLayout;
                this.redrawGroupBlock(block, parentGroup, layer);
                let newElementGroup = parentGroup.getChildren().filter(l => l.getAttr("fieldId") === currentField.id)[0];
                newElementGroup.fire('click');
            }
        );
    }

    appendGridFieldTransformEvent(elementGroup, parentGroup, block, layer) {
        elementGroup.on('transform', () => {
                let newWidth = elementGroup.scaleX() * elementGroup.width();
                let currentField = parentGroup.getAttr("gridFields").filter(l => l.id === elementGroup.getAttr("fieldId"))[0];
                if (newWidth > this.canvas.stage.width())
                    newWidth = this.canvas.stage.width();
                currentField.width = Math.floor(newWidth / 16).toString() + "em";
                this.redrawGridBlock(block, parentGroup, layer);
                let newElementGroup = parentGroup.getChildren().filter(l => l.getAttr("fieldId") === currentField.id)[0];
                newElementGroup.fire('click');
            }
        );
    }

    drawGroupBlock(group, layer, block) {
        let fieldX = 0;
        let fieldY = Math.max(...group.getChildren().filter(l => l.name() !== "borderRect").map(l => l.y() + l.height()));
        block.fields = group.getAttr("fields");
        for (let field of group.getAttr("fields")) {
            if (field.layout && field.layout !== EditScreenFieldLayout.normal) {
                fieldX = 0;
                fieldY = Math.max(...group.getChildren().filter(l => l.name() !== "borderRect").map(l => l.y() + l.height()));
            }
            let shape = this.createField(field, fieldX, fieldY);
            if (!shape)
                continue;
            this.appendFieldDraggingEvent(shape, group, block, layer, (block, group, layer) => this.redrawGroupBlock(block, group, layer), "NamaHeaderField", "fields", "name");
            this.appendHeaderFieldTransformEvent(shape, group, block, layer);
            this.onFieldClicked(shape, group, layer, block, this.HEADER_FIELD_TYPE)
            group.add(shape);
            fieldX = shape.x() + shape.width();
            if (fieldX >= this.canvas.stage.width() || field.layout === EditScreenFieldLayout.alone) {
                fieldX = 0;
                fieldY = shape.y() + shape.height();
            }
        }
    }

    drawGridFields(block, group, layer) {
        let lineX = 0;
        let rowNumber = 0;
        let lineY = Math.max(...group.getChildren().filter(l => l.name() !== "borderRect").map(l => l.y() + l.height()));
        let gridFields = group.getAttr("gridFields");
        block.columns = gridFields;
        for (let column of gridFields) {
            let shape = this.createGridField(column, lineX, lineY, rowNumber, block.id, group);
            if (!shape)
                continue;
            this.appendFieldDraggingEvent(shape, group, block, layer, (block, group, layer) => this.redrawGridBlock(block, group, layer), "NamaGridField", "gridFields", "globalName");
            this.appendGridFieldTransformEvent(shape, group, block, layer);
            this.onFieldClicked(shape, group, layer, block, this.GRID_FIELD_TYPE)
            group.add(shape);
            lineX = shape.x() + shape.width();
            if (lineY !== shape.y()) {
                lineY = shape.y();
                rowNumber++;
            }
            if (lineX === this.canvas.stage.width() || gridFields[gridFields.length - 1] === column) {
                this.resetRowHeightsToTallestElement(group, block.id, rowNumber);
                lineX = 0;
                lineY = shape.y() + shape.height();
                rowNumber++;
            }
        }
    }

    setGroupAndBorderRectHeight(blockGroup, block) {
        let height = Math.max(...blockGroup.getChildren().filter(l => l.name() !== "borderRect").map(n => n.height() + n.y()));
        if (blockGroup.getChildren().filter(l => l.name() !== "borderRect").length > 0) {
            if (block.editScreenGrid && block.columns) {
                blockGroup.setAttr("childrenHeight", height);
                let gridSize = internalGridSizeToPixels(block.gridSize);
                blockGroup.height(height + gridSize);
            } else {
                blockGroup.height(height);
            }
        } else {
            blockGroup.height(0);
        }
        blockGroup.getChildren().filter(l => l.name() === "borderRect")[0].height(blockGroup.height())
    }

    onActionsBlockTitleClicked(block, group, layer) {
        $("#groupPropsActions").append(
            `<button class="btn btn-success m-1" id="modifyGUIActionBlockBtn">Modify GUI Action Block</button>
                    <button class="btn btn-danger m-1" id="deleteActionBlock">Delete Block</button>
                    <button class="btn btn-success m-1" id="copyActionBlockToAnotherPage">Copy Block To Another Page</button>
                    <button class="btn btn-success m-1" id="moveActionBlockToAnotherPage">Move Block To Another Page</button>`);
        $("#deleteActionBlock").on('click', () => {
            group.destroy();
            this.resetIndexes(layer.find(".NamaBlock"));
            layer.draw();
            this.resetNamaBlocksHeights(layer);
            block.actions.forEach(action => {
                let indexOfAction = this.originalActions.indexOf(action);
                this.originalActions.splice(indexOfAction, 1);
            })
        })
        $("#copyActionBlockToAnotherPage").on('click', () => {
            this.moveGroupToAnotherLayer(false, group, layer);
        })
        $("#moveActionBlockToAnotherPage").on('click', () => {
            this.moveGroupToAnotherLayer(true, group, layer);
        })
        $("#modifyGUIActionBlockBtn").on('click', () => {
            this.fetchEditLayoutBeforeMe((editLayoutBeforeMe) => {
                let entityActions = this.preferences.metaData.entityActions.actions;
                let existedActions = group.getAttr("actions");
                existedActions.forEach(f => {
                    f.text = ts.translateTitledId(this.entityType, f)
                    f.searchData = f.id + " " + ts.translateTitledIdAr(this.entityType, f) + " " + ts.translateTitledIdEn(this.entityType, f)
                });
                let allowedGUIAction = [];
                for (let entityAction of entityActions) {
                    if (existedActions.some(f => f.id === entityAction.id))
                        continue;
                    allowedGUIAction.push({
                        text: translateId(entityAction.id),
                        searchData: entityAction.id + " " + translateIdAr(entityAction.id) + " " + translateIdEn(entityAction.id),
                        id: entityAction.id,
                        customization: {
                            empty: true,
                            entityFlowId: null,
                            guiPostActionsId: null,
                            notificationId: null,
                            performActionAsField: null,
                            query: null,
                            reportInfo: null,
                            urlTemplate: null
                        },
                        hasTitle: false,
                        layout: null,
                        showInQuickCreate: true,
                        title: null,
                        titlePercentage: -1,
                        widgetPercentage: -1,
                        namaClassTypeId: "GUIActionPlaceholder"
                    })
                }
                editLayoutBeforeMe.pages.map(page => page.blocks).flat().filter(block => block.namaClassTypeId === "EditScreenActionsBlock")
                    .map(l => l.actions).flat().filter(l => l.customization && (l.customization.entityFlowId || l.customization.guiPostActionsId ||
                    l.customization.notificationId || l.customization.urlTemplate || l.customization.reportInfo)).forEach(e => {
                    e.text = ts.translateTitledId(this.entityType, e)
                    e.searchData = e.id + " " + ts.translateTitledIdAr(this.entityType, e) + " " + ts.translateTitledIdEn(this.entityType, e)
                    allowedGUIAction.push(e);
                })
                if (editLayoutBeforeMe.moreActions)
                    editLayoutBeforeMe.moreActions.filter(l => l.customization &&
                        (l.customization.entityFlowId || l.customization.guiPostActionsId || l.customization.notificationId || l.customization.urlTemplate || l.customization.reportInfo))
                        .filter(l => l.title && !existedActions.filter(l => l.title).map(action => action.title)
                            .some(t => areEqual(t.resourceId, l.title.resourceId) || (areEqual(t.arabicText, l.title.arabicText) && areEqual(t.englishText, l.title.englishText))))
                        .forEach(e => {
                            e.text = ts.translateTitledId(this.entityType, e)
                            e.searchData = e.id + " " + ts.translateTitledIdAr(this.entityType, e) + " " + ts.translateTitledIdEn(this.entityType, e)
                            allowedGUIAction.push(e);
                        })
                this.drawModifyActionsDialog(existedActions, allowedGUIAction, (selectedList) => {
                    group.setAttr("actions", selectedList)
                    this.redrawActionsBlock(block, group, layer);
                });
            })
        })
    }

    drawModifyActionsDialog(selectedData, optionalData, callbackOnSave) {
        let dialog = $("<div id='modifyGUIActionBlockDialog'></div>").kendoDialog({
            width: "650px",
            title: "Select GUI Actions To Add",
            closable: true,
            modal: false,
            content: `<div class='d-flex flex-column'>
                <input type='text' id='searchBox' class='k-input k-textbox k-input-solid k-input-md k-rounded-md' placeholder='search items' />
                <br />
                <div class='d-flex justify-content-between'>
                <div class='d-flex flex-column justify-content-center'>
                <h5 class='text-center'>Optional</h5>
                <select id='optional' style='width: 300px'></select>
                </div>
                <div  class='d-flex flex-column justify-content-center'>
                <h5 class='text-center'>Selected</h5>
                <select id='selected' style='width: 300px'></select>
                </div>
                </div><br />
                <div class='d-flex justify-content-center'><button class='btn btn-success' id='saveActions'>Save</button></div>
                </div>`,
            close: function () {
                this.destroy();
                let optionalListBox = $("#optional").getKendoListBox();
                if (optionalListBox)
                    optionalListBox.destroy();
                let selectedListBox = $("#selected").getKendoListBox();
                if (selectedListBox)
                    selectedListBox.destroy();
            }
        }).data("kendoDialog");
        dialog.open();
        $("#searchBox").on("input", function (e) {
            let listBox = $("#optional").getKendoListBox();
            let searchString = $(this).val();
            listBox.dataSource.filter({
                field: "searchData",
                operator: "contains",
                value: searchString
            });
        });
        let optional = $("#optional").kendoListBox({
            connectWith: "selected",
            draggable: true,
            dropSources: ["selected"],
            toolbar: {
                position: "right",
                tools: ["transferTo", "transferFrom", "transferAllTo", "transferAllFrom"]
            },
            selectable: "multiple",
            dataSource: optionalData,
            dataTextField: "text",
            dataValueField: "id"
        }).data("kendoListBox");
        let selected = $("#selected").kendoListBox({
            connectWith: "optional",
            draggable: {
                placeholder: function (element) {
                    return element.clone().css({
                        "opacity": 0.3,
                        "border": "1px dashed #000000"
                    });
                }
            },
            reorder: function (e) {
                e.preventDefault();
                let dataSource = e.sender.dataSource;
                let dataItem = e.dataItems[0]
                let index = dataSource.indexOf(dataItem) + e.offset;
                dataSource.remove(dataItem);
                dataSource.insert(index, dataItem);
            },
            dataSource: selectedData,
            dropSources: ["optional"],
            selectable: "multiple",
            dataTextField: "text",
            dataValueField: "id",
            toolbar: {
                position: "right",
                tools: ["moveUp", "moveDown", "remove"]
            }
        }).data("kendoListBox");
        dialog.center();
        optional.wrapper.find(".k-item").on("dblclick", function (e) {
            optional._executeCommand("transferTo");
        });

        selected.wrapper.find(".k-item").on("dblclick", function (e) {
            optional._executeCommand("transferFrom");
        });
        $("#saveActions").on('click', () => {
            let selectedListBox = $("#selected").getKendoListBox();
            callbackOnSave(selectedListBox.dataItems());
            dialog.close();
        })
    }

    redrawActionsBlock(block, blockGroup, layer) {
        blockGroup.find(".NamaGUIAction").forEach(n => n.destroy());
        this.appendActionsToWidget(blockGroup, layer, block);
        this.refreshLayerAndBlocksHeights(blockGroup, block, layer);
    }

    refreshLayerAndBlocksHeights(blockGroup, block, layer) {
        if (blockGroup.getChildren().length <= 2) {
            blockGroup.destroy();
            this.resetIndexes(layer.find(".NamaBlock"));
        }
        layer.draw();
        if (blockGroup.getChildren().length) {
            this.setGroupAndBorderRectHeight(blockGroup, block);
        }
        this.resetNamaBlocksHeights(layer);
    }

    resetIndexes(blocks) {
        blocks.sort((a, b) => this.sortByProperty(a, b, "y"))
        for (let i = 0; i < blocks.length; i++) {
            blocks[i].setAttr("index", i);
        }
    }

    sortByProperty(a, b, property) {
        if (a.getAttr(property) < b.getAttr(property)) {
            return -1;
        }
        if (a.getAttr(property) > b.getAttr(property)) {
            return 1;
        }
        return 0;
    }

    onGridTitleClicked(block, group, layer) {
        $("#groupPropsActions").append(
            `<button class="btn btn-success m-1" id="modifyGridBlockBtn">Modify Grid Block Fields</button>
                    <button class="btn btn-danger m-1" id="deleteGridBlock">Delete Block</button>
                    <button class="btn btn-success m-1" id="copyGridBlockToAnotherPage">Copy Block To Another Page</button>
                    <button class="btn btn-success m-1" id="moveGridBlockToAnotherPage">Move Block To Another Page</button>`);
        $("#deleteGridBlock").on('click', () => {
            group.destroy();
            this.resetIndexes(layer.find(".NamaBlock"));
            layer.draw();
            this.resetNamaBlocksHeights(layer);
            let indexOfBlock = this.originalGridBlocks.indexOf(block);
            this.originalGridBlocks.splice(indexOfBlock, 1);
        });
        $("#copyGridBlockToAnotherPage").on('click', () => {
            this.moveGroupToAnotherLayer(false, group, layer);
        })
        $("#moveGridBlockToAnotherPage").on('click', () => {
            this.moveGroupToAnotherLayer(true, group, layer);
        })
        $("#modifyGridBlockBtn").on('click', () => {
            let existedGridFields = group.getAttr("gridFields");
            let subFields = this.preferences.metaData.detailFields.get(block.id).subFields;
            let remainingGridFields = [];
            for (let subField of subFields) {
                let id = subField.fieldId;
                if (existedGridFields.some(e => e.id === id))
                    continue;
                remainingGridFields.push({
                    id: id,
                    text: translateId(id),
                    searchData: id + " " + translateIdAr(id) + " " + translateIdEn(id),
                    showInGridView: true,
                    showInFullView: true,
                    showOnlyInLang: null,
                    title: null,
                    width: "6em",
                })
            }
            existedGridFields.forEach(f => {
                f.text = translateId(f.id)
                f.searchData = f.id + " " + translateIdAr(f.id) + " " + translateIdEn(f.id)
            })
            let dialog = $("<div id='modifyGridBlockDialog'></div>").kendoDialog({
                width: "650px",
                title: "Select Grid Fields To Show",
                closable: true,
                modal: false,
                content: "<div class='d-flex flex-column'>" +
                    "<input type='text' id='gridFieldsSearchBox' class='k-input k-textbox k-input-solid k-input-md k-rounded-md' placeholder='search items' />" +
                    "<br />" +
                    "<div class='d-flex justify-content-between'>" +
                    "<div class='d-flex flex-column justify-content-center'>" +
                    "<h5 class='text-center'>Optional</h5>" +
                    "<select id='optionalGridFields' style='width: 300px'></select>" +
                    "</div>" +
                    "<div  class='d-flex flex-column justify-content-center'>" +
                    "<h5 class='text-center'>Selected</h5>" +
                    "<select id='selectedGridFields' style='width: 300px'></select>" +
                    "</div>" +
                    "</div><br />" +
                    "<div class='d-flex justify-content-center'><button class='btn btn-success' id='saveGridFields'>Save</button></div>" +
                    "</div>",
                close: function () {
                    this.destroy();
                    let optionalListBox = $("#optionalGridFields").getKendoListBox();
                    if (optionalListBox)
                        optionalListBox.destroy();
                    let selectedListBox = $("#selectedGridFields").getKendoListBox();
                    if (selectedListBox)
                        selectedListBox.destroy();
                }
            }).data("kendoDialog");
            dialog.open();
            $("#gridFieldsSearchBox").on("input", function (e) {
                let listBox = $("#optionalGridFields").getKendoListBox();
                let searchString = $(this).val();
                listBox.dataSource.filter({
                    field: "searchData",
                    operator: "contains",
                    value: searchString
                });
            });
            let optional = $("#optionalGridFields").kendoListBox({
                connectWith: "selectedGridFields",
                draggable: true,
                dropSources: ["selectedGridFields"],
                toolbar: {
                    position: "right",
                    tools: ["transferTo", "transferFrom", "transferAllTo", "transferAllFrom"]
                },
                selectable: "multiple",
                dataSource: remainingGridFields,
                dataTextField: "text",
                dataValueField: "id"
            }).data("kendoListBox");
            let selected = $("#selectedGridFields").kendoListBox({
                connectWith: "optionalGridFields",
                draggable: {
                    placeholder: function (element) {
                        return element.clone().css({
                            "opacity": 0.3,
                            "border": "1px dashed #000000"
                        });
                    }
                },
                reorder: function (e) {
                    e.preventDefault();
                    let dataSource = e.sender.dataSource;
                    let dataItem = e.dataItems[0]
                    let index = dataSource.indexOf(dataItem) + e.offset;
                    dataSource.remove(dataItem);
                    dataSource.insert(index, dataItem);
                },
                dataSource: existedGridFields,
                dropSources: ["optionalGridFields"],
                selectable: "multiple",
                dataTextField: "text",
                dataValueField: "id",
                toolbar: {
                    position: "right",
                    tools: ["moveUp", "moveDown", "remove"]
                }
            }).data("kendoListBox");
            optional.wrapper.find(".k-item").on("dblclick", function (e) {
                optional._executeCommand("transferTo");
            });

            selected.wrapper.find(".k-item").on("dblclick", function (e) {
                optional._executeCommand("transferFrom");
            });
            $("#saveGridFields").on('click', () => {
                let selectedListBox = $("#selectedGridFields").getKendoListBox();
                group.setAttr("gridFields", selectedListBox.dataItems())
                this.redrawGridBlock(block, group, layer);
                dialog.close();
            })
        })
        $(`#gridSizeDropDown`).kendoDropDownList({
            value: block.gridSize,
            dataSource: [GridSize.Tiny, GridSize.VerySmall, GridSize.Small, GridSize.Medium, GridSize.Large, GridSize.XLarge, GridSize.XXLarge],
            change: (e) => {
                let newValue = e.sender.value();
                block.gridSize = newValue;
                this.onGridSizeChange(group, newValue, layer);
            }
        }).data("kendoDropDownList");
    }

    appendActionsToWidget(group, layer, block) {
        let actionX = 0;
        let actionY = Math.max(...group.getChildren().filter(l => l.name() !== "borderRect").map(l => l.y() + l.height()));
        let padding = 6;
        block.actions = group.getAttr("actions");
        for (let action of group.getAttr("actions")) {
            let guiAction = this.createGUIAction(action, actionX, actionY, padding, group);
            this.appendFieldDraggingEvent(guiAction, group, block, layer, (block, group, layer) => this.redrawActionsBlock(block, group, layer), "NamaGUIAction", "actions", "name");
            this.onGUIActionClicked(guiAction, action, group, layer, block);
            group.add(guiAction);
            actionX = guiAction.x() + guiAction.width();
            if (actionY + padding / 2 !== guiAction.y())
                actionY = guiAction.y() - padding / 2;
            if (actionX === this.canvas.stage.width()) {
                actionX = 0;
                actionY = guiAction.y() + guiAction.height();
            }
        }
    }

    onGridSizeChange(group, newValue, layer) {
        let childrenHeight = group.getAttr("childrenHeight");
        let gridSize = internalGridSizeToPixels(newValue);
        group.height(childrenHeight + gridSize);
        group.find(".borderRect")[0].height(childrenHeight + gridSize);
        this.reOrderNamaBlocksAndResetStageHeight(layer);
        this.clearAllTransformers();
        group.find('.gridTitle')[0].fire('click');
    }

    reOrderNamaBlocksAndResetStageHeight(layer) {
        let sortedBlocks = layer.find('.NamaBlock').sort(function (a, b) {
            return a.getAttr("index") - b.getAttr("index");
        });
        let y = 0;
        for (let i = 0; i < sortedBlocks.length; i++) {
            let current = sortedBlocks[i];
            current.y(y);
            y += current.height();
        }
        let layerHeight = Math.max(...sortedBlocks.map(l => l.height() + l.y()))
        this.canvas.stage.height(layerHeight);
    }

    appendPagesDropDownAndSaveBtn() {
        let that = this;
        $("#props").append(
            `<div class="d-flex justify-content-center px-2 py-1" style="width: 100%;">
            <button class="btn btn-success" style="width: 40%;" id="saveChanges">Save Changes</button>
            </div>
            <div class="d-flex justify-content-between px-2 py-1">
                <label for="pageDropDown" class="h5 m-0">Page</label>
                <input id="pageDropDown" class="text-center" style="width: 50%">
            </div>
            <div class="d-flex" style="flex-wrap:wrap">
                <button class="btn btn-success m-1" id="addNewPage">Add New Page</button>
                <button class="btn btn-success m-1" id="deleteCurrentPage">Delete Current Page</button>
                <button class="btn btn-primary m-1" id="getDifferences">Get Differences</button>
                <button class="btn btn-secondary m-1" id="controlMoreAction">Control More Actions</button>
            </div>
            <div class="d-flex flex-column" style="text-align:start;border: #69696b 1px solid;border-radius:10px;margin: 3px;padding: 3px">
                <div class="d-flex justify-content-center py-1">
                <h5 class="m-0">Page Properties</h5>
                </div>
                <hr class="my-1" style="height: 1px;width: 100%;background-color: #69696b">
                <div class="d-flex justify-content-between px-2 py-3">
                    <div class="h6 my-0" style="width: 60%;text-align:start">Switch To Page After Move</div>
                    <input type="checkbox" style="width: 45%" id="switchToPageAfterMove">
                </div>
                <div class="d-flex justify-content-between px-2 py-1">
                <div class="h6" style="width: 30%">Arabic Page Title</div>
                <input id="arabicPageTitle" type="text" style="width: 50%">
                </div>
                <div class="d-flex justify-content-between px-2 py-1">
                <div class="h6" style="width: 30%">English Page Title</div>
                <input id="englishPageTitle" type="text" style="width: 50%">
                </div>
                <div class="d-flex" style="flex-wrap:wrap">
                    <button class="btn btn-secondary m-1" id="addNewGroup">Add New Group</button>
                    <button class="btn btn-secondary m-1" id="addNewGrid">Add New Grid</button>
                    <button class="btn btn-secondary m-1" id="addNewActionBlock">Add New Action Block</button>
                    <button class="btn btn-secondary m-1" id="addNewDiscussion">Add New Discussion</button>
                </div>
            </div>`);
        $("#saveChanges").on("click", () => {
            this.editLayout.pages = [];
            for (let pageNumber in this.cachedLayers) {
                let newPage = this.cachedLayers[pageNumber].getAttr("page");
                newPage.blocks = this.cachedLayers[pageNumber].find(".NamaBlock").sort((a, b) => this.sortByProperty(a, b, "index")).map(l => l.getAttr("block"));
                this.editLayout.pages.push(newPage);
            }
            ajaxJSON("screenModifierEditor", {
                layout: JSON.stringify(this.editLayout),
                documentId: this.id,
                action: "save"
            });
        })
        let values = [];
        for (let i = 0; i < this.editLayout.pages.length; i++) {
            let current = this.editLayout.pages[i];
            values.push({text: ts.translateNaMaText(current.title), value: i})
        }
        let pageDropDown = that.pageDropDown = $(`#pageDropDown`).kendoDropDownList({
            dataValueField: "value",
            dataTextField: "text",
            dataSource: values,
            change: function (e) {
                $("#props").find(".property").remove();
                $("#pointerName").text("");
                let newValue = Number(e.sender.value());
                that.changeLayer(newValue)
            }
        }).data("kendoDropDownList");
        $("#addNewGroup").on('click', () => {
            let currentLayer = this.cachedLayers[Number(pageDropDown.value())];
            this.createNewGroupBtnClick(currentLayer, "editScreenGroup", "EditScreenGroup");
        })
        $("#addNewGrid").on('click', () => {
            let dialog = $("<div></div>").kendoDialog({
                width: "450px",
                title: "Select Targeted Grid Id",
                closable: true,
                content: "<div class='d-flex flex-column align-items-center'>" +
                    "<input type='text' id='targetGridId' class='k-input k-textbox k-input-solid k-input-md k-rounded-md p-0' style='width: 80%'/>" +
                    "<br />" +
                    "<button class='btn btn-success' id='createGrid'>Save</button>" +
                    "</div>",
                close: function () {
                    this.destroy();
                    let targetGridIdDropDown = $("#targetGridId").getKendoListBox();
                    if (targetGridIdDropDown)
                        targetGridIdDropDown.destroy();
                }
            }).data("kendoDialog");
            dialog.open();
            let dataSource = [];
            this.preferences.metaData.detailFields.forEach(detailField => {
                let lineId = detailField.fieldId;
                dataSource.push({
                    text: translateId(lineId) + " (" + lineId + ")",
                    searchData: lineId + " " + translateIdAr(lineId) + " " + translateIdEn(lineId),
                    value: lineId,
                })
            })
            let targetGridId = $("#targetGridId").kendoDropDownList({
                filter: "contains",
                dataSource: dataSource,
                dataValueField: "value",
                dataTextField: "text",
                filtering: function (ev) {
                    dropDownFiltering(ev, this.dataSource);
                }
            }).data("kendoDropDownList");
            $("#createGrid").on('click', () => {
                let currentLayer = this.cachedLayers[Number(pageDropDown.value())];
                this.createNewGroupBtnClick(currentLayer, "editScreenGrid", "EditScreenGrid", targetGridId.value());
                dialog.close();
            })
        })
        $("#addNewActionBlock").on('click', () => {
            let currentLayer = this.cachedLayers[Number(pageDropDown.value())];
            this.createNewGroupBtnClick(currentLayer, "editScreenActionsBlock", "EditScreenActionsBlock");
        })
        $("#addNewDiscussion").on('click', () => {
            let currentLayer = this.cachedLayers[Number(pageDropDown.value())];
            this.createNewDiscussionBlock(currentLayer);
        })
        $("#addNewPage").on('click', () => {
            let newPage = {
                title: {
                    arabicText: 'صفحة جديدة ' + (that.editLayout.pages.length + 1),
                    englishText: 'New Page ' + (that.editLayout.pages.length + 1)
                },
                blocks: []
            }
            that.addNewPage(newPage);
        });
        $("#deleteCurrentPage").on('click', () => {
            let selectedPageIndex = Number(pageDropDown.value());
            that.editLayout.pages.splice(selectedPageIndex, 1);
            that.originalPages.splice(selectedPageIndex, 1);
            delete this.cachedLayers[selectedPageIndex];
            pageDropDown.dataSource.data(pageDropDown.dataSource.data().filter(l => l !== pageDropDown.dataSource.data()[selectedPageIndex]));
            pageDropDown.select(0);
            for (let key in that.cachedLayers) {
                if (that.cachedLayers[key]) {
                    that.changeLayer(key);
                    break;
                }
            }
        });
        $("#controlMoreAction").on('click', () => {
            that.fetchEditLayoutBeforeMe((editLayoutBeforeMe) => {
                let existedActions = this.editLayout.moreActions || [];
                this.editLayout.moreActions = existedActions;
                existedActions.forEach(f => {
                    f.text = ts.translateTitledId(this.entityType, f)
                    f.searchData = f.id + " " + ts.translateTitledIdAr(this.entityType, f) + " " + ts.translateTitledIdEn(this.entityType, f)
                });
                let allowedGUIAction = [];
                let entityActions = this.preferences.metaData.entityActions.actions;
                for (let entityAction of entityActions) {
                    if (existedActions.some(f => f.id === entityAction.id))
                        continue;
                    allowedGUIAction.push({
                        text: translateId(entityAction.id),
                        searchData: entityAction.id + " " + translateIdAr(entityAction.id) + " " + translateIdEn(entityAction.id),
                        id: entityAction.id,
                        customization: {
                            empty: true,
                            entityFlowId: null,
                            guiPostActionsId: null,
                            notificationId: null,
                            performActionAsField: null,
                            query: null,
                            reportInfo: null,
                            urlTemplate: null
                        },
                        hasTitle: false,
                        layout: null,
                        showInQuickCreate: true,
                        title: null,
                        titlePercentage: -1,
                        widgetPercentage: -1,
                        namaClassTypeId: "GUIActionPlaceholder"
                    })
                }
                editLayoutBeforeMe.pages.map(page => page.blocks).flat().filter(block => block.namaClassTypeId === "EditScreenActionsBlock")
                    .map(l => l.actions).flat().filter(l => l.customization && (l.customization.entityFlowId || l.customization.guiPostActionsId ||
                    l.customization.notificationId || l.customization.urlTemplate || l.customization.reportInfo)).forEach(e => {
                    e.text = ts.translateTitledId(this.entityType, e)
                    e.searchData = e.id + " " + ts.translateTitledIdAr(this.entityType, e) + " " + ts.translateTitledIdEn(this.entityType, e)
                    allowedGUIAction.push(e);
                })
                editLayoutBeforeMe.moreActions.filter(l => l.customization &&
                    (l.customization.entityFlowId || l.customization.guiPostActionsId || l.customization.notificationId || l.customization.urlTemplate || l.customization.reportInfo))
                    .filter(l => l.title && !existedActions.filter(l => l.title).map(action => action.title)
                        .some(t => areEqual(t.resourceId, l.title.resourceId) || (areEqual(t.arabicText, l.title.arabicText) && areEqual(t.englishText, l.title.englishText))))
                    .forEach(e => {
                        e.text = ts.translateTitledId(this.entityType, e)
                        e.searchData = e.id + " " + ts.translateTitledIdAr(this.entityType, e) + " " + ts.translateTitledIdEn(this.entityType, e)
                        allowedGUIAction.push(e);
                    })
                that.drawModifyActionsDialog(existedActions, allowedGUIAction, (selectedList) => {
                    this.editLayout.moreActions = selectedList;
                });
            })
        })
        $("#getDifferences").on('click', () => {
            that.fetchEditLayoutBeforeMe((editLayoutBeforeMe) => {
                if (editLayoutBeforeMe === null)
                    return;
                let diffs = [];
                for (let page of editLayoutBeforeMe.pages) {
                    if (that.originalPages.filter(l => (l.title ? l.title.resourceId : null) === page.title.resourceId).length === 0) {
                        page.namaClassTypeId = "Page";
                        diffs.push(page);
                    }
                }
                let allBlocks = editLayoutBeforeMe.pages.map(page => page.blocks).flat();
                allBlocks.filter(block => block.namaClassTypeId === "EditScreenGroup")
                    .filter(b => !b.title).forEach(b => {
                    if (that.areGroupNotIntersectWithOriginal(b))
                        diffs.push(b);
                })
                allBlocks.filter(block => block.namaClassTypeId === "EditScreenGroup")
                    .filter(b => b.title && !that.originalGroupBlocks.filter(l => l.title).map(block => block.title)
                        .some(t => areEqual(t.resourceId, b.title.resourceId) || (areEqual(t.arabicText, b.title.arabicText) && areEqual(t.englishText, b.title.englishText))))
                    .forEach(b => {
                        diffs.push(b);
                    })
                allBlocks.filter(block => block.namaClassTypeId === "EditScreenGrid")
                    .filter(b => !that.originalGridBlocks.map(ob => ob.fieldId).contains(b.fieldId)).forEach(b => {
                    diffs.push(b);
                })
                allBlocks.filter(block => block.namaClassTypeId === "EditScreenActionsBlock")
                    .map(l => l.actions).flat().filter(b => !that.originalActions.filter(l => l.id).map(action => action.id).contains(b.id)).filter(b =>
                    !that.isTitleExist(b)).forEach(b => {
                    diffs.push(b);
                })
                allBlocks.filter(block => block.namaClassTypeId === "EditScreenList")
                    .filter(b => !that.originalLists.some(l => areEqual(b.listViewId, l.listViewId) && areEqual(b.listViewEntityType, l.listViewEntityType) && areEqual(b.linkFieldId, l.linkFieldId)))
                    .forEach(b => {
                        diffs.push(b);
                    })
                allBlocks.filter(block => block.namaClassTypeId === "EditScreenReport")
                    .filter(b => !that.originalReports.some(l => areEqual(b.reportInfo.reportId, l.reportInfo.reportId) &&
                        (b.title && l.title && (areEqual(l.title.resourceId, b.title.resourceId) || (areEqual(l.title.arabicText, b.title.arabicText) && areEqual(l.title.englishText, b.title.englishText))))))
                    .forEach(b => {
                        diffs.push(b);
                    })
                allBlocks.filter(block => block.namaClassTypeId === "EditScreenDashBoard")
                    .filter(b => !that.originalDashBoard.some(l => areEqual(b.reportInfo.reportId, l.reportInfo.reportId) &&
                        (b.title && l.title && (areEqual(l.title.resourceId, b.title.resourceId) || (areEqual(l.title.arabicText, b.title.arabicText) && areEqual(l.title.englishText, b.title.englishText))))))
                    .forEach(b => {
                        diffs.push(b);
                    })
                diffs.forEach(e => {
                    e.arTitle = ts.translateTitledIdAr(this.entityType, e);
                    e.enTitle = ts.translateTitledIdEn(this.entityType, e);
                })
                that.drawDifferencesDialog(diffs);
            });
        });
    }

    fetchEditLayoutBeforeMe(callback) {
        ajaxJSON("screenModifierEditor", {
            documentId: this.id,
            forType: this.entityType,
            action: "fetchLayoutBeforeMe",
        }, (data) => {
            if (callback !== null)
                callback(data)
        })
    }

    addNewPage(newPage) {
        this.editLayout.pages.push(newPage);
        let pageIndex = this.editLayout.pages.indexOf(newPage);
        while (this.cachedLayers[pageIndex] !== undefined) {
            pageIndex++;
        }
        this.cachedLayers[pageIndex] = this.drawPage(this.editLayout.pages.indexOf(newPage));
        this.pageDropDown.dataSource.data().push({text: ts.translateNaMaText(newPage.title), value: pageIndex});
        this.pageDropDown.select(this.pageDropDown.dataSource.data().length - 1);
        this.pageDropDown.trigger('change');
    }

    /**
     *
     * @param b {namaTypes.EditScreenGroup}
     */
    areGroupNotIntersectWithOriginal(b) {
        return !this.originalGroupBlocks.filter(l => !l.title).some(l => {
            let matchedCount = 0;
            for (let i = 0; i < b.fields.length; i++) {
                if (matchedCount >= 3)
                    break;
                if (l.fields.map(l => l.id).contains(b.fields[i].id))
                    matchedCount++;
            }
            return matchedCount === b.fields.length || matchedCount >= 3;
        })
    }

    /**
     *
     * @param b {namaTypes.GUIActionPlaceholder}
     */
    isTitleExist(b) {
        if (!b.title && b.customization) {
            return this.originalActions.filter(l => !l.title && !l.id).map(action => action.customization).some(c =>
                areEqual(c.entityFlowId, b.customization.entityFlowId) ||
                areEqual(c.guiPostActionsId, b.customization.guiPostActionsId) ||
                areEqual(c.notificationId, b.customization.notificationId) ||
                areEqual(c.urlTemplate, b.customization.urlTemplate) ||
                (b.customization.reportInfo && c.reportInfo && areEqual(c.reportInfo.reportId, b.customization.reportInfo.reportId)));
        }
        return this.originalActions.filter(l => l.title && !l.id).map(action => action.title).some(t => areEqual(t.resourceId, b.title.resourceId) || (areEqual(t.arabicText, b.title.arabicText) && areEqual(t.englishText, b.title.englishText)));
    }

    drawDifferencesDialog(data) {
        let that = this;
        let dialog = $("<div></div>").kendoDialog({
            width: "1150px",
            title: "Layout Differences",
            closable: true,
            content: `<div id="diffsGrid"></div>`,
            close: function () {
                this.destroy();
            }
        }).data("kendoDialog");
        dialog.open();
        let grid = $("#diffsGrid").kendoGrid({
            dataSource: data,
            height: 550,
            columns: [
                {field: "namaClassTypeId", title: "Type"},
                {field: "arTitle", title: "Arabic Title"},
                {field: "enTitle", title: "English Title"},
                {command: {text: "Add", click: addSelectedLayoutToView}, title: " "}],
        }).getKendoGrid();
        dialog.center();

        function addSelectedLayoutToView(e) {
            e.preventDefault();
            let dataItem = grid.dataItem($(e.currentTarget).closest("tr"))
            let layer = that.cachedLayers[Number(that.pageDropDown.value())];
            if (dataItem.namaClassTypeId === "Page") {
                that.addNewPage(dataItem);
            } else if (dataItem.namaClassTypeId === "GUIActionPlaceholder" && layer.find(".NamaBlock").filter(l => l.getAttr("actions")).length) {
                that.originalActions.push(dataItem);
                let actionsGroup = layer.find(".NamaBlock").filter(l => l.getAttr("actions"))[0];
                actionsGroup.getAttr("actions").push(dataItem);
                that.redrawActionsBlock(actionsGroup.getAttr("block"), actionsGroup, layer);
            } else {
                let block = dataItem;
                if (dataItem.namaClassTypeId === "GUIActionPlaceholder") {
                    block = {
                        editScreenGroup: false,
                        editScreenGrid: false,
                        editScreenActionsBlock: true,
                        editScreenDashBoard: false,
                        editScreenList: false,
                        editScreenReport: false,
                        namaClassTypeId: "EditScreenActionsBlock",
                        actions: [dataItem],
                    };
                }
                let blockY = Math.max(...layer.find(".NamaBlock").map(l => l.height() + l.y())) - 5;
                let group = that.createKonvaGroupFromBlock(block, layer, blockY, 0);
                that.setGroupAndBorderRectHeight(group, block);
                layer.add(group);
                that.resetIndexes(layer.find(".NamaBlock"));
                that.resetNamaBlocksHeights(layer);
                $("#layoutEditor").animate({scrollTop: group.y()}, 1000)
            }
            grid.removeRow($(e.currentTarget).closest("tr"));
        }
    }

    createNewGroupBtnClick(layer, activeProperty, namaClassTypeId, gridId) {
        let that = this;
        let block = {
            editScreenGroup: false,
            editScreenGrid: false,
            editScreenActionsBlock: false,
            editScreenDashBoard: false,
            editScreenList: false,
            editScreenReport: false,
            columns: [],
            actions: [],
            fields: [],
            gridSize: GridSize.Medium
        };
        block[activeProperty] = true;
        block["namaClassTypeId"] = namaClassTypeId;
        if (activeProperty === "editScreenGrid" && gridId !== undefined) {
            block["id"] = block["fieldId"] = gridId;
        }
        let blockY = Math.max(...layer.find(".NamaBlock").map(l => l.height() + l.y())) - 5;
        if (that.noResizableTransformer.nodes() && that.noResizableTransformer.nodes().length > 0 && that.noResizableTransformer.nodes()[0].hasName("NamaBlock")) {
            blockY = that.noResizableTransformer.nodes()[0].y() + 5;
        }
        let group = this.createKonvaGroupFromBlock(block, layer, blockY, 0);
        this.setGroupAndBorderRectHeight(group, block);
        layer.add(group);
        that.resetIndexes(layer.find(".NamaBlock"));
        that.resetNamaBlocksHeights(layer);
        group.find('.gridTitle')[0].fire('click');
        if (activeProperty === "editScreenGrid") {
            $("#modifyGridBlockBtn").click();
        } else if (activeProperty === "editScreenActionsBlock") {
            $("#modifyGUIActionBlockBtn").click();
        } else if (activeProperty === "editScreenGroup") {
            $("#modifyGroupBlockBtn").click();
        }
        $("#layoutEditor").animate({scrollTop: group.y()}, 1000)
    }

    appendBlockTitle(block) {
        let group = new Konva.Group({
            x: 0,
            y: 0,
            width: this.canvas.backgroundGridCellWidth * 2,
            height: this.canvas.backgroundGridCellHeight,
            name: "gridTitle"
        });
        group.add(new Konva.Rect({
            fill: "#fcfaf7",
            stroke: "#dfdac9",
            strokeWidth: .5,
            width: this.canvas.backgroundGridCellWidth * 2,
            height: this.canvas.backgroundGridCellHeight
        }))

        group.add(new Konva.Text({
            text: ts.translateTitledId(this.entityType, block),
            height: this.canvas.backgroundGridCellHeight,
            align: 'center',
            verticalAlign: 'middle',
            x: 5
        }));

        return group;
    }

    /**
     *
     * @returns {namaTypes.EditScreenLayout}
     */
    get editLayout() {
        let editLayout = this.editLayoutTillMe;
        if (this.place.isQuickCreatorView)
            return editLayout.quickCreatorScreen || editLayout;
        if (this.place.isMobileView)
            return editLayout.mobileScreen || editLayout;
        return editLayout;
    }

    /**
     *
     * @returns {namaTypes.NaMaMetaData}
     */
    get metadata() {
        return this.preferences[PreferencesRequest.META_DATA];
    }


    /**
     *
     * @param field {namaTypes.EditScreenField}
     * @returns {Konva.Group}
     */
    createField(field, x, y) {
        let cellWidth = this.canvas.backgroundGridCellWidth;
        let cellHeight = this.canvas.backgroundGridCellHeight;
        let labelWidth;
        if (field.layout === EditScreenFieldLayout.spanned || field.layout === EditScreenFieldLayout.spanned2) {
            cellWidth = cellWidth * 2;
            labelWidth = cellWidth / 8;
            if (field.layout === EditScreenFieldLayout.spanned2)
                cellHeight = cellHeight * 2;
        } else {
            labelWidth = cellWidth / 4;
        }
        let yPadding = 5;
        let group = new Konva.Group({
            width: cellWidth,
            height: cellHeight,
            draggable: true,
            x: x,
            y: y,
            name: "NamaHeaderField",
            fieldId: field.id
        });
        group.add(new Konva.Rect({
                width: cellWidth,
                height: cellHeight,
                fill: '#f7f7f7',
                stroke: '#f7f7f7',
                strokeWidth: 0.5
            }),
            new Konva.Text({
                text: ts.translateTitledId(this.entityType, field),
                width: labelWidth,
                height: cellHeight,
                align: 'center',
                verticalAlign: 'middle',
                name: "text"
            })
        )
        if (field.subFields) {
            let subX = labelWidth;
            let fullWidth = cellWidth - labelWidth;
            group.setAttr("hasSubFields", true);
            group.setAttr("subFields", field.subFields);
            this.CREATED_COMPOSITE_FIELDS_COUNT++;
            for (let subField of field.subFields) {
                let width = (fullWidth * subField.widgetPercentage / 100) - yPadding;
                if (subField.widgetPercentage < 0)
                    width = (fullWidth * 0.5) - yPadding;
                group.add(new Konva.Rect({
                    cornerRadius: 6,
                    width: width,
                    height: cellHeight - yPadding,
                    x: subX + yPadding / 2,
                    y: yPadding / 2,
                    fill: "white",
                    stroke: "black",
                    strokeWidth: 1,
                }))
                subX += width + yPadding / 2;
            }
        } else if (field.customization) {
            //TODO
        } else {
            let width = cellWidth - labelWidth - yPadding;
            group.add(new Konva.Rect({
                cornerRadius: 8,
                width: width,
                height: cellHeight - yPadding,
                y: yPadding / 2,
                x: labelWidth + yPadding / 2,
                fill: "white",
                stroke: "black",
                strokeWidth: 1,
            }))
            // if (this.canvas.isRTL)
            //     group.scaleX(-1)
        }
        group.on('click tap', () => {
            this.clearAllTransformers();
            group.moveToTop();
            this.headerFieldTransformer.nodes([group])
            this.headerFieldTransformer.moveToTop();
        })
        return group;
    }

    createGridField(column, x, y, rowNumber, gridName, parent) {
        if (!column.width)
            column.width = "6em";
        let width = Number(column.width.replace('em', '')) * 16;
        let group = new Konva.Group({
            draggable: true,
            x: x,
            y: y,
            width: width,
            name: gridName + "-row-" + rowNumber,
            globalName: "NamaGridField",
            fieldId: column.id
        });
        let rect = new Konva.Rect({
            width: width,
            fill: "#f5f1e6",
            stroke: "#dfdac9",
            strokeWidth: .5,
            name: 'rect'
        })
        let textNode = new Konva.Text({
            text: ts.translateTitledId(this.entityType, column.id),
            align: 'center',
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
            fontSize: 12,
            padding: 4,
            fill: '#000000',
            width: width,
            name: 'text'
        })
        let emptyCellRect = new Konva.Rect({
            width: width,
            height: this.gridEmptyCellHeight,
            y: textNode.height(),
            fill: "#ffff83",
            stroke: "#dfdac9",
            strokeWidth: .5,
            name: 'emptyRect'
        })
        rect.height(textNode.height())
        group.add(rect);
        group.add(textNode);
        group.add(emptyCellRect);
        group.height(textNode.height() + emptyCellRect.height())
        if (group.x() + group.width() > this.canvas.stage.width()) {
            this.resetRowHeightsToTallestElement(parent, gridName, rowNumber);
            let maxHeight = Math.max(...parent.find('.' + gridName + "-row-" + rowNumber).map(l => l.height()));
            group.x(0);
            group.y(y + maxHeight);
            rowNumber++;
            group.name(gridName + "-row-" + rowNumber);
        }
        group.on('click tap', () => {
            this.clearAllTransformers();
            this.gridFieldTransformer.nodes([group]);
            group.moveToTop();
            this.gridFieldTransformer.moveToTop();
        })
        return group;
    }

    resetRowHeightsToTallestElement(parent, gridName, rowNumber) {
        let maxHeight = Math.max(...parent.find('.' + gridName + "-row-" + rowNumber).map(l => l.height()))
        parent.find('.' + gridName + "-row-" + rowNumber).forEach(n => {
            n.height(maxHeight);
            let textHeight = maxHeight - this.gridEmptyCellHeight;
            n.find('.rect')[0].height(textHeight);
            n.find('.text')[0].height(textHeight);
            n.find('.emptyRect')[0].y(textHeight);
        })
    }

    createGUIAction(action, x, y, padding, parent) {
        let titleToShow = ts.translateId(action.id);
        if (action.title && (action.title.resourceId || action.title.arabicText || action.title.englishText))
            titleToShow = ts.translateNaMaText(action.title);
        let group = new Konva.Group({
            draggable: true,
            x: x + padding,
            y: y + padding / 2,
            name: "NamaGUIAction",
            fieldId: action
        });
        let rectNode = new Konva.Rect({
            cornerRadius: 5,
            fill: "#f46515",
            stroke: "#f46515",
            strokeWidth: .5
        });
        group.add(rectNode)
        let textNode = new Konva.Text({
            text: titleToShow,
            align: 'center',
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
            fontSize: 16,
            padding: 10,
            fill: '#FFFFFF',
            alpha: 0.75,
            name: "text"
        })
        group.add(textNode);
        group.width(textNode.width());
        group.height(textNode.height() + padding);
        rectNode.width(textNode.width());
        rectNode.height(textNode.height());
        if (group.x() + group.width() > this.canvas.stage.width()) {
            group.x(padding);
            group.y(Math.max(...parent.getChildren().filter(l => l.name() !== "borderRect").map(l => l.height() + l.y())) + padding / 2);
        }
        return group;
    }

    clearAllTransformers() {
        $("#props").find(".property").remove();
        $("#pointerName").text("");
        this.transformers.forEach(tr => {
            tr.nodes([])
        })
    }

    onGUIActionClicked(guiActionGroup, action, parentGroup, layer, block) {
        let that = this;
        guiActionGroup.on('click tap', () => {
            this.clearAllTransformers();
            this.noResizableTransformer.nodes([guiActionGroup]);
            guiActionGroup.moveToTop();
            this.noResizableTransformer.moveToTop();
            this.onBlockTitleClicked(parentGroup, block, layer);
            $("#props").append(
                `<div class="d-flex flex-column property" style="text-align:start;border: #69696b 1px solid;border-radius:10px;margin: 3px;padding: 3px">
                <div class="d-flex justify-content-center py-1">
                <h5 class="m-0">Field Properties</h5>
                </div>
                <hr class="my-1" style="height: 1px;width: 100%;background-color: #69696b">
                <div class="d-flex justify-content-between px-2 py-1">
                <div class="h6" style="width: 30%">GUI Action Id</div>
                <input disabled type="text" value="${action.id}" style="width: 50%">
                </div>
                <div class="d-flex justify-content-between px-2 py-1">
                <div class="h6" style="width: 30%">Arabic Field Title</div>
                <input class="arabicGUIText" type="text" value="${ts.translateTitledIdAr(this.entityType, action)}" style="width: 50%">
                </div>
                <div class="d-flex justify-content-between px-2 py-1">
                <div class="h6" style="width: 30%">English Field Title</div>
                <input class="englishGUIText"  type="text" value="${ts.translateTitledIdEn(this.entityType, action)}" style="width: 50%">
                </div>
                <button class="btn btn-danger mx-2" id="deleteGUIActionBlockBtn" style="width: 40%;">Delete GUI Action</button>
                </div>`);
            let fieldsArray = parentGroup.getAttr("actions");
            let myField = fieldsArray.filter(l => l.id === action.id)[0];
            $(".arabicGUIText").on('change', function () {
                myField.title = {
                    arabicText: $(this).val() ? $(this).val() : null,
                    englishText: $(".englishGUIText").val() ? $(".englishGUIText").val() : null
                };
                if (guiActionGroup.find(".text")[0]) {
                    guiActionGroup.find(".text")[0].text(ts.translateTitledId(that.entityType, myField));
                } else {
                    guiActionGroup = parentGroup.find(".NamaGUIAction").filter(l => l.attrs.fieldId.id === guiActionGroup.attrs.fieldId.id)[0];
                    guiActionGroup.find(".text")[0].text(ts.translateTitledId(that.entityType, myField));
                }
                that.redrawActionsBlock(block, parentGroup, layer);
            })
            $(".englishGUIText").on('change', function () {
                myField.title = {
                    arabicText: $(".arabicGUIText").val() ? $(".arabicGUIText").val() : null,
                    englishText: $(this).val() ? $(this).val() : null
                };
                if (guiActionGroup.find(".text")[0]) {
                    guiActionGroup.find(".text")[0].text(ts.translateTitledId(that.entityType, myField));
                } else {
                    guiActionGroup = parentGroup.find(".NamaGUIAction").filter(l => l.attrs.fieldId.id === guiActionGroup.attrs.fieldId.id)[0];
                    guiActionGroup.find(".text")[0].text(ts.translateTitledId(that.entityType, myField));
                }
                that.redrawActionsBlock(block, parentGroup, layer);
            })
            $("#deleteGUIActionBlockBtn").on('click', () => {
                this.onDeleteGUIActionClicked(parentGroup, action, layer, block);
            });
            this.canvas.stage.container().tabIndex = 1;
            this.canvas.stage.container().focus();
            this.canvas.stage.container().addEventListener('keyup', (e) => {
                if (e.keyCode === 46 && this.noResizableTransformer.nodes().contains(guiActionGroup))
                    this.onDeleteGUIActionClicked(parentGroup, action, layer, block);
            });
        })
    }

    onDeleteGUIActionClicked(parentGroup, action, layer, block) {
        let indexOfAction = this.originalActions.indexOf(action);
        this.originalActions.splice(indexOfAction, 1);
        parentGroup.setAttr("actions", parentGroup.getAttr('actions').filter(l => l.id !== action.id));
        this.redrawActionsBlock(block, parentGroup, layer);
    }

    redrawGridBlock(block, group, layer) {
        group.find(node => {
            return node.getAttr("globalName") === "NamaGridField";
        }).forEach(n => n.destroy());
        this.drawGridFields(block, group, layer);
        this.refreshLayerAndBlocksHeights(group, block, layer);
    }

    redrawGroupBlock(block, group, layer) {
        group.find(".NamaHeaderField").forEach(n => n.destroy());
        this.drawGroupBlock(group, layer, block);
        this.refreshLayerAndBlocksHeights(group, block, layer);
    }

    onFieldClicked(fieldGroup, parentGroup, layer, block, fieldType) {
        let that = this;
        fieldGroup.on('click tap', () => {
            this.clearAllTransformers();
            let currentTransformer;
            let fieldsArrayPropName;
            if (fieldType === this.HEADER_FIELD_TYPE) {
                currentTransformer = this.headerFieldTransformer;
                fieldsArrayPropName = "fields";
            } else if (fieldType === this.GRID_FIELD_TYPE) {
                currentTransformer = this.gridFieldTransformer;
                fieldsArrayPropName = "gridFields";
            }
            this.onBlockTitleClicked(parentGroup, block, layer);
            let fieldsArray = parentGroup.getAttr(fieldsArrayPropName);
            let buttonId = `delete${fieldType}Btn`;
            currentTransformer.nodes([fieldGroup]);
            currentTransformer.moveToTop();
            fieldGroup.moveToTop();
            let fieldId = fieldGroup.getAttr('fieldId');
            let myField = fieldsArray.filter(l => l.id === fieldId)[0];
            let htmlContent = `<div class="d-flex flex-column property" style="text-align:start;border: #69696b 1px solid;border-radius:10px;margin: 3px;padding: 3px">
            <div class="d-flex justify-content-center py-1">
            <h5 class="m-0">Field Properties</h5>
            </div>
            <hr class="my-1" style="height: 1px;width: 100%;background-color: #69696b">
            <div class="d-flex justify-content-between px-2 py-1">
            <div class="h6" style="width: 30%">Field Id</div>
            <input disabled type="text" value="${fieldId}" style="width: 50%">
            </div>
            <div class="d-flex justify-content-between px-2 py-1">
            <div class="h6" style="width: 30%">Arabic Field Title</div>
            <input class="arabicFieldText" type="text" value="${ts.translateTitledIdAr(that.entityType, myField)}" style="width: 50%">
            </div>
            <div class="d-flex justify-content-between px-2 py-1">
            <div class="h6" style="width: 30%">English Field Title</div>
            <input class="englishFieldText" type="text" value="${ts.translateTitledIdEn(that.entityType, myField)}" style="width: 50%">
            </div>`
            if (fieldType === this.GRID_FIELD_TYPE) {
                if (myField.showInGridView)
                    htmlContent += `<div class="d-flex justify-content-between px-2 py-3">
                        <div class="h6 my-0" style="width: 30%">Show In Grid View</div>
                        <input type="checkbox" style="width: 50%" id="showInGridViewCheckBox" checked></div>`
                else
                    htmlContent += `<div class="d-flex justify-content-between px-2 py-3">
                                <div class="h6 my-0" style="width: 30%">Show In Grid View</div>
                                <input type="checkbox" style="width: 50%" id="showInGridViewCheckBox"></div>`
            }
            if (fieldType === this.HEADER_FIELD_TYPE) {
                htmlContent += `<div class="d-flex justify-content-between px-2 py-1">
                <label for="headerFieldLayout" class="h6 m-0"  style="width: 30%">Field Layout</label>
                <input id="headerFieldLayout" class="text-center" style="width: 50%">
                </div>`;
            }
            htmlContent += `<div class="d-flex" style="flex-wrap: wrap">`;
            let labelAfterWidget = false;
            if (fieldGroup.getAttr("hasSubFields") === true) {
                labelAfterWidget = myField.labelAfterWidget;
                htmlContent += `<button class="btn btn-secondary mx-2" style="width: fit-content;" id="editCompositeProps">Edit Composite Field Properties</button>`;
            }
            htmlContent += `<button class="btn btn-danger mx-2 ${buttonId}" style="width: fit-content;">Delete Field</button></div></div>`;
            $("#props").append(htmlContent);
            $("#editCompositeProps").on('click', () => {
                let dialog = $("<div></div>").kendoDialog({
                    width: "1150px",
                    title: "Composite Field Properties",
                    closable: true,
                    content: `<div class='d-flex flex-column w-100'>
                        <div class='d-flex justify-content-between px-2 py-1 w-50'>
                        <div class='h6 my-0' style='width: 30%'>Label After Widget</div>
                        <input type='checkbox' style='width: 50%' id='labelAfterWidget'></div>
                        <div class="subFieldsGrid my-1"></div>
                        <div class='d-flex justify-content-center'><button class='btn btn-success' id='saveSubFields'>Save</button></div>
                        </div>`,
                    close: function () {
                        this.destroy();
                    }
                }).data("kendoDialog");
                dialog.open();
                $("#labelAfterWidget").prop("checked", labelAfterWidget);
                for (let subField of myField.subFields) {
                    subField.arTitle = ts.translateTitledIdAr(this.entityType, subField);
                    subField.enTitle = ts.translateTitledIdEn(this.entityType, subField);
                }
                let grid = $(".subFieldsGrid").kendoGrid({
                    dataSource: myField.subFields,
                    height: 550,
                    toolbar: ["create"],
                    columns: [
                        {draggable: true, width: "40px"},
                        {field: "id", title: "Field Id"},
                        {title: "Arabic Title", field: "arTitle"},
                        {title: "English Title", field: "enTitle"},
                        {field: "hasTitle", title: "Has Title"},
                        {field: "widgetPercentage", title: "Widget Percentage"},
                        {field: "titlePercentage", title: "Title Percentage"},
                        {command: "destroy", title: " "},
                        {command: {text: "Select Field", click: selectField}, title: " "}],
                    editable: true,
                    reorderable: {
                        rows: true
                    },
                }).getKendoGrid();
                dialog.center();
                $(".subFieldsGrid .k-grid-add").first().on("click", function (e) {
                    setTimeout(() => {
                        selectField(0);
                    }, 100);
                });
                $("#saveSubFields").on('click', () => {
                    for (let item of grid.dataItems()) {
                        item.title = {
                            arabicText: item.arTitle,
                            englishText: item.enTitle
                        }
                    }
                    myField.labelAfterWidget = $("#labelAfterWidget").prop("checked");
                    myField.subFields = grid.dataItems();
                    grid.destroy();
                    dialog.close();
                });

                function selectField(eOrRow) {
                    if (eOrRow.preventDefault)
                        eOrRow.preventDefault();
                    that.openFieldSelectorForCompositeFields(eOrRow, grid);
                }
            })
            $(".arabicFieldText").on('change', function () {
                myField.title = {
                    arabicText: $(this).val() ? $(this).val() : null,
                    englishText: $(".englishFieldText").val() ? $(".englishFieldText").val() : null
                };
                fieldGroup.find(".text")[0].text(ts.translateTitledId(that.entityType, myField));
            })
            $(".englishFieldText").on('change', function () {
                myField.title = {
                    arabicText: $(".arabicFieldText").val() ? $(".arabicFieldText").val() : null,
                    englishText: $(this).val() ? $(this).val() : null
                };
                fieldGroup.find(".text")[0].text(ts.translateTitledId(that.entityType, myField));
            })
            $("#showInGridViewCheckBox").on('change', () => {
                let showInGridViewCheckBox = $("#showInGridViewCheckBox");
                myField.showInGridView = showInGridViewCheckBox.prop("checked");
            })
            if ($("#headerFieldLayout").length && fieldType === this.HEADER_FIELD_TYPE) {
                $(`#headerFieldLayout`).kendoDropDownList({
                    dataValueField: "value",
                    dataTextField: "text",
                    dataSource: [{
                        text: "Normal",
                        value: EditScreenFieldLayout.normal
                    }, {
                        text: "Alone",
                        value: EditScreenFieldLayout.alone
                    }, {
                        text: "Start New Line",
                        value: EditScreenFieldLayout.startnewline
                    }, {
                        text: "Spanned",
                        value: EditScreenFieldLayout.spanned
                    }, {
                        text: "Spanned 2",
                        value: EditScreenFieldLayout.spanned2
                    }],
                    value: myField.layout,
                    change: (e) => {
                        myField.layout = e.sender.value();
                        parentGroup.setAttr(fieldsArrayPropName, fieldsArray);
                        this.redrawGroupBlock(block, parentGroup, layer);
                        let newElementGroup = parentGroup.getChildren().filter(l => l.getAttr("fieldId") === myField.id)[0];
                        newElementGroup.fire('click');
                    }
                }).data("kendoDropDownList");
            }
            $(`.${buttonId}`).on('click', () => {
                this.onDeleteFieldClicked(parentGroup, fieldId, layer, block, fieldType);
                this.clearAllTransformers();
            });
            this.canvas.stage.container().tabIndex = 1;
            this.canvas.stage.container().focus();
            this.canvas.stage.container().addEventListener('keyup', (e) => {
                if (e.keyCode === 46 && currentTransformer.nodes().contains(fieldGroup)) {
                    this.onDeleteFieldClicked(parentGroup, fieldId, layer, block, fieldType);
                    this.clearAllTransformers();
                }
            });
        })
    }

    openFieldSelectorForCompositeFields(eOrRow, grid) {
        let dataItem;
        if (eOrRow.currentTarget)
            dataItem = grid.dataItem($(eOrRow.currentTarget).closest("tr"));
        else
            dataItem = grid.dataItem(grid.items(eOrRow))
        let dialog = $("<div></div>").kendoDialog({
            width: "350px",
            title: "Select Fields",
            closable: true,
            content: "<div class='d-flex flex-column'>" +
                "<input type='text' class='k-input k-textbox k-input-solid k-input-md k-rounded-md selectFieldIdSearchBox' placeholder='search items' />" +
                "<br />" +
                "<div class='d-flex justify-content-between'>" +
                "<select class='selectFieldIdListBox' style='width: 300px'></select>" +
                "</div><br />" +
                "<div class='d-flex justify-content-center'><button class='btn btn-success saveSelectFieldIdListBox'>Save</button></div>" +
                "</div>",
            close: function () {
                this.destroy();
            }
        }).data("kendoDialog");
        dialog.open();
        let allHeaderFields = this.preferences.metaData.fieldsMetaData.filter(l => l.headerField);
        let remainingFields = [];
        allHeaderFields.forEach(f => {
            let id = f.fieldId;
            remainingFields.push({
                id: id,
                text: translateId(id),
                searchData: id + " " + translateIdAr(id) + " " + translateIdEn(id),
                hasTitle: false,
                labelAfterWidget: null,
                layout: null,
                showInQuickCreate: true,
                title: null,
                titlePercentage: -1,
                widgetPercentage: -1,
                namaClassTypeId: "EditScreenField"
            });
        })
        let listBox = $(".selectFieldIdListBox").kendoListBox({
            dataSource: remainingFields,
            dataTextField: "text",
            dataValueField: "id",
        }).data("kendoListBox");
        listBox.select(listBox.items().first());
        $(".selectFieldIdSearchBox").on("input", function (e) {
            let searchString = $(this).val();
            listBox.dataSource.filter({
                field: "searchData",
                operator: "contains",
                value: searchString
            });
        });
        listBox.wrapper.find(".k-item").on("dblclick", (e) => {
            this.saveSelectedFromListBox(listBox, dataItem, grid, dialog);
        });
        $(".saveSelectFieldIdListBox").on('click', () => {
            this.saveSelectedFromListBox(listBox, dataItem, grid, dialog);
        });
    }

    saveSelectedFromListBox(listBox, dataItem, grid, dialog) {
        let selectedField = listBox.dataItem(listBox.select());
        dataItem.id = selectedField.id;
        dataItem.arTitle = ts.translateTitledIdAr(this.entityType, selectedField);
        dataItem.enTitle = ts.translateTitledIdEn(this.entityType, selectedField);
        dataItem.hasTitle = false;
        dataItem.labelAfterWidget = null;
        dataItem.layout = null;
        dataItem.showInQuickCreate = true;
        dataItem.title = null;
        dataItem.titlePercentage = -1;
        dataItem.widgetPercentage = -1;
        dataItem.namaClassTypeId = "EditScreenField";
        grid.refresh();
        dialog.close();
    }

    onDeleteFieldClicked(parentGroup, fieldId, layer, block, fieldType) {
        if (fieldType === this.GRID_FIELD_TYPE) {
            parentGroup.setAttr("gridFields", parentGroup.getAttr('gridFields').filter(l => l.id !== fieldId));
            this.redrawGridBlock(block, parentGroup, layer);
        }
        if (fieldType === this.HEADER_FIELD_TYPE) {
            parentGroup.setAttr("fields", parentGroup.getAttr('fields').filter(l => l.id !== fieldId));
            this.redrawGroupBlock(block, parentGroup, layer);
        }
    }

    onGroupTitleClicked(group, block, layer) {
        let that = this;
        $("#groupPropsActions").append(
            `<button class="btn btn-success m-1" id="modifyGroupBlockBtn">Modify Group Block</button>
                    <button class="btn btn-danger m-1" id="deleteGroupBlock">Delete Block</button>
                    <button class="btn btn-success m-1" id="copyGroupBlockToAnotherPage">Copy Block To Another Page</button>
                    <button class="btn btn-success m-1" id="moveGroupBlockToAnotherPage">Move Block To Another Page</button>
                    <button class="btn btn-secondary m-1" id="addCompositeHeaderField">Add Composite Field</button>`);
        $("#deleteGroupBlock").on('click', () => {
            group.destroy();
            this.resetIndexes(layer.find(".NamaBlock"));
            layer.draw();
            this.resetNamaBlocksHeights(layer);
            let indexOfBlock = that.originalGroupBlocks.indexOf(block);
            that.originalGroupBlocks.splice(indexOfBlock, 1);
        })
        $("#copyGroupBlockToAnotherPage").on('click', () => {
            this.moveGroupToAnotherLayer(false, group, layer);
        })
        $("#moveGroupBlockToAnotherPage").on('click', () => {
            this.moveGroupToAnotherLayer(true, group, layer);
        })
        $("#modifyGroupBlockBtn").on('click', () => {
            let allHeaderFields = this.preferences.metaData.fieldsMetaData.filter(l => l.headerField);
            let existedFields = group.getAttr("fields");
            let remainingFields = [];
            for (let filed of allHeaderFields) {
                let id = filed.fieldId;
                if (existedFields.some(f => f.id === id))
                    continue;
                remainingFields.push({
                    id: id,
                    text: translateId(id),
                    searchData: id + " " + translateIdAr(id) + " " + translateIdEn(id),
                    hasTitle: false,
                    labelAfterWidget: null,
                    layout: null,
                    showInQuickCreate: true,
                    title: null,
                    titlePercentage: -1,
                    widgetPercentage: -1,
                    namaClassTypeId: "EditScreenField"
                });
            }
            existedFields.forEach(f => {
                f.text = translateId(f.id)
                f.searchData = f.id + " " + translateIdAr(f.id) + " " + translateIdEn(f.id)
            });
            let dialog = $("<div id='modifyGroupBlockDialog'></div>").kendoDialog({
                width: "650px",
                title: "Select Fields To Show",
                closable: true,
                modal: false,
                content: "<div class='d-flex flex-column'>" +
                    "<input type='text' id='headerFieldsSearchBox' class='k-input k-textbox k-input-solid k-input-md k-rounded-md' placeholder='search items' />" +
                    "<br />" +
                    "<div class='d-flex justify-content-between'>" +
                    "<div class='d-flex flex-column justify-content-center'>" +
                    "<h5 class='text-center'>Optional</h5>" +
                    "<select id='optionalHeaderFields' style='width: 300px'></select>" +
                    "</div>" +
                    "<div  class='d-flex flex-column justify-content-center'>" +
                    "<h5 class='text-center'>Selected</h5>" +
                    "<select id='selectedHeaderFields' style='width: 300px'></select>" +
                    "</div>" +
                    "</div><br />" +
                    "<div class='d-flex justify-content-center'><button class='btn btn-success' id='saveHeaderFields'>Save</button></div>" +
                    "</div>",
                close: function () {
                    this.destroy();
                    let optionalListBox = $("#optionalHeaderFields").getKendoListBox();
                    if (optionalListBox)
                        optionalListBox.destroy();
                    let selectedListBox = $("#selectedHeaderFields").getKendoListBox();
                    if (selectedListBox)
                        selectedListBox.destroy();
                }
            }).data("kendoDialog");
            dialog.open();
            $("#headerFieldsSearchBox").on("input", function (e) {
                let listBox = $("#optionalHeaderFields").getKendoListBox();
                let searchString = $(this).val();
                listBox.dataSource.filter({
                    field: "searchData",
                    operator: "contains",
                    value: searchString
                });
            });
            let optional = $("#optionalHeaderFields").kendoListBox({
                connectWith: "selectedHeaderFields",
                draggable: true,
                dropSources: ["selectedHeaderFields"],
                toolbar: {
                    position: "right",
                    tools: ["transferTo", "transferFrom", "transferAllTo", "transferAllFrom"]
                },
                selectable: "multiple",
                dataSource: remainingFields,
                dataTextField: "text",
                dataValueField: "id"
            }).data("kendoListBox");
            let selected = $("#selectedHeaderFields").kendoListBox({
                connectWith: "optionalHeaderFields",
                draggable: {
                    placeholder: function (element) {
                        return element.clone().css({
                            "opacity": 0.3,
                            "border": "1px dashed #000000"
                        });
                    }
                },
                reorder: function (e) {
                    e.preventDefault();
                    let dataSource = e.sender.dataSource;
                    let dataItem = e.dataItems[0]
                    let index = dataSource.indexOf(dataItem) + e.offset;
                    dataSource.remove(dataItem);
                    dataSource.insert(index, dataItem);
                },
                dataSource: existedFields,
                dropSources: ["optionalHeaderFields"],
                selectable: "multiple",
                dataTextField: "text",
                dataValueField: "id",
                toolbar: {
                    position: "right",
                    tools: ["moveUp", "moveDown", "remove"]
                }
            }).data("kendoListBox");
            optional.wrapper.find(".k-item").on("dblclick", function (e) {
                optional._executeCommand("transferTo");
            });

            selected.wrapper.find(".k-item").on("dblclick", function (e) {
                optional._executeCommand("transferFrom");
            });
            $("#saveHeaderFields").on('click', () => {
                let selectedListBox = $("#selectedHeaderFields").getKendoListBox();
                group.setAttr("fields", selectedListBox.dataItems())
                this.redrawGroupBlock(block, group, layer);
                dialog.close();
            })
        })
        $("#addCompositeHeaderField").on('click', () => {
            let dialog = $("<div></div>").kendoDialog({
                width: "1150px",
                title: "Composite Field Properties",
                closable: true,
                content: `<div class='d-flex flex-column w-100'>
                        <div class='d-flex justify-content-between px-2 py-1 w-50'>
                        <div class='h6 my-0' style='width: 30%'>Arabic Title</div>
                        <input type='text' style='width: 50%' id='arabicTitleForComposite'></div>
                        <div class='d-flex justify-content-between px-2 py-1 w-50'>
                        <div class='h6 my-0' style='width: 30%'>English Title</div>
                        <input type='text' style='width: 50%' id='englishTitleForComposite'></div>
                        <div class='d-flex justify-content-between px-2 py-1 w-50'>
                        <div class='h6 my-0' style='width: 30%'>Label After Widget</div>
                        <input type='checkbox' style='width: 50%' id='labelAfterWidget'></div>
                        <div class="my-1 subFieldsGrid"></div>
                        <div class='d-flex justify-content-center'><button class='btn btn-success' id='saveNewCompositeField'>Save</button></div>
                        </div>`,
                close: function () {
                    this.destroy();
                }
            }).data("kendoDialog");
            dialog.open();
            let grid = $(".subFieldsGrid").kendoGrid({
                height: 550,
                toolbar: ["create"],
                columns: [
                    {draggable: true, width: "40px"},
                    {field: "id", title: "Field Id"},
                    {title: "Arabic Title", field: "arTitle"},
                    {title: "English Title", field: "enTitle"},
                    {field: "hasTitle", title: "Has Title"},
                    {field: "widgetPercentage", title: "Widget Percentage"},
                    {field: "titlePercentage", title: "Title Percentage"},
                    {command: "destroy", title: " "},
                    {command: {text: "Select Field", click: selectField}, title: " "}],
                editable: true,
                reorderable: {
                    rows: true
                },
            }).getKendoGrid();
            dialog.center();
            $(".subFieldsGrid .k-grid-add").first().on("click", function (e) {
                setTimeout(() => {
                    selectField(0);
                }, 100);
            });

            $("#saveNewCompositeField").on('click', () => {
                for (let item of grid.dataItems()) {
                    item.title = {
                        arabicText: item.arTitle,
                        englishText: item.enTitle
                    }
                }
                let newField = {
                    id: "CompositeField" + that.CREATED_COMPOSITE_FIELDS_COUNT,
                    hasTitle: false,
                    labelAfterWidget: $("#labelAfterWidget").prop("checked"),
                    layout: null,
                    showInQuickCreate: true,
                    title: {
                        arabicText: $("#arabicTitleForComposite").val(),
                        englishText: $("#englishTitleForComposite").val()
                    },
                    titlePercentage: -1,
                    widgetPercentage: -1,
                    namaClassTypeId: "CompositeEditScreenField",
                    subFields: grid.dataItems()
                }
                that.CREATED_COMPOSITE_FIELDS_COUNT++;
                group.getAttr("fields").push(newField);
                this.redrawGroupBlock(block, group, layer);
                dialog.close();
            })

            function selectField(eOrRow) {
                if (eOrRow.preventDefault)
                    eOrRow.preventDefault();
                that.openFieldSelectorForCompositeFields(eOrRow, grid);
            }
        });
    }

    moveGroupToAnotherLayer(isMove, group, layer) {
        let that = this;
        let dialog = $("<div id='copyBlockToAnotherPage'></div>").kendoDialog({
            width: "450px",
            title: "Select Targeted Page",
            closable: true,
            content: "<div class='d-flex flex-column align-items-center'>" +
                "<input type='text' id='targetPage' class='k-input k-textbox k-input-solid k-input-md k-rounded-md p-0'/>" +
                "<br />" +
                "<button class='btn btn-success' id='makeCopy'>Save</button>" +
                "</div>",
            close: function () {
                this.destroy();
                let targetPageDropDown = $("#targetPage").getKendoListBox();
                if (targetPageDropDown)
                    targetPageDropDown.destroy();
            }
        }).data("kendoDialog");
        dialog.open();
        let targetPage = $("#targetPage").kendoDropDownList({
            filter: "contains",
            dataSource: that.pageDropDown.dataSource,
            dataValueField: "value",
            dataTextField: "text",
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            }
        }).data("kendoDropDownList");
        $("#makeCopy").on('click', () => {
            if (isMove && (that.pageDropDown.value() === targetPage.value())) {
                dialog.close();
                return;
            }
            let targetedLayer = that.cachedLayers[Number(targetPage.value())];
            let targetedLayerHeight = Math.max(...targetedLayer.find(".NamaBlock").map(l => l.height() + l.y()))
            let instance = group.clone();
            if (isMove) {
                instance = group;
                targetedLayer.add(instance)
                that.clearAllTransformers();
                that.resetIndexes(layer.find(".NamaBlock"));
                that.resetNamaBlocksHeights(layer);
            } else {
                targetedLayer.add(instance)
                if (that.pageDropDown.value() === targetPage.value())
                    targetedLayerHeight = group.y() + 5;
            }
            targetedLayer.find(".NamaBlock").filter(l => l === instance)[0].y(targetedLayerHeight + 5);
            that.resetIndexes(targetedLayer.find(".NamaBlock"));
            that.resetNamaBlocksHeights(targetedLayer);
            dialog.close();
            if (that.pageDropDown.value() === targetPage.value()) {
                $("#layoutEditor").animate({scrollTop: instance.y()}, 1000)
            } else if ($("#switchToPageAfterMove").prop("checked")) {
                that.pageDropDown.select(Number(targetPage.value()));
                that.pageDropDown.trigger("change");
                $("#layoutEditor").animate({scrollTop: instance.y()}, 1000)
            }
        })
    }

    appendCustomEditScreenBlockKonvaGroup(parentGroup, text) {
        let width = 1280;
        let height = internalGridSizeToPixels(GridSize.XLarge);
        let y = Math.max(...parentGroup.getChildren().filter(l => l.name() !== "borderRect").map(l => l.y() + l.height()));
        let group = new Konva.Group({
            name: "customBlock",
            width: width,
            height: height,
            y: y
        });
        group.add(new Konva.Rect({
            width: width,
            fill: "#f5f1e6",
            strokeWidth: .5,
            stroke: "#000000",
            name: "borderRect"
        }));
        group.add(new Konva.Text({
            text: text,
            width: width,
            height: height,
            align: 'center',
            verticalAlign: 'middle',
            fontFamily: 'Calibri',
            fontSize: 20,
            fill: '#FFFFFF',
        }));
        parentGroup.add(group);
    }

    createNewDiscussionBlock(layer) {
        let that = this;
        let block = {
            editScreenGroup: false,
            editScreenGrid: false,
            editScreenActionsBlock: false,
            editScreenDashBoard: false,
            editScreenList: false,
            editScreenReport: false,
            editScreenBlock: true,
            columns: [],
            actions: [],
            fields: [],
            gridSize: GridSize.Medium
        };
        block["namaClassTypeId"] = "EditScreenBlock";
        block["fieldId"] = "discussions";
        let blockY = Math.max(...layer.find(".NamaBlock").map(l => l.height() + l.y())) - 5;
        if (that.noResizableTransformer.nodes() && that.noResizableTransformer.nodes().length > 0 && that.noResizableTransformer.nodes()[0].hasName("NamaBlock")) {
            blockY = that.noResizableTransformer.nodes()[0].y() + 5;
        }
        let group = this.createKonvaGroupFromBlock(block, layer, blockY, 0);
        this.setGroupAndBorderRectHeight(group, block);
        layer.add(group);
        that.resetIndexes(layer.find(".NamaBlock"));
        that.resetNamaBlocksHeights(layer);
        $("#layoutEditor").animate({scrollTop: group.y()}, 1000)
    }
}
